export default {
  init() {
    
  },
  finalize() {
    setTimeout(function(){ 
    	console.log('entrei');
    	$('#user_login').attr( 'placeholder', 'LOGIN' );
		$('#user_pass').attr( 'placeholder', 'PASSWORD' );	
     }, 500);
    

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/download-center-en.js